'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LegacyTablerIconSize } from '#pplx/frontend/aether/primitives/IconPrimitive/iconSizing.js';
import { IconPrimitive } from '#pplx/frontend/aether/primitives/IconPrimitive/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { composerStyles } from '#pplx/frontend/composer-sdk/styles.js';
import { useComposer } from '#pplx/frontend/composer-sdk/useComposer.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import React from 'react';
export const RightAttribution = React.memo(function RightAttribution({ isLoading, children }) {
    const { isExpanded } = useComposer();
    return (_jsxs("div", { className: classNames(...composerStyles.attribution.right.base, {
            [composerStyles.attribution.right.expanded]: isExpanded,
            [composerStyles.attribution.right.compact]: !isExpanded,
        }), children: [isLoading ? (_jsx(TextPrimitive, { color: "light", className: "mr-3", children: _jsx(IconPrimitive, { icon: $icon('loader-2'), size: LegacyTablerIconSize.xs, className: "animate-spin" }) })) : null, children] }));
});
//# sourceMappingURL=RightAttribution.js.map